import { z } from 'zod';

import { FreddieMacEDRV1 } from '../investorReporting/FreddieMac/FreddieMacEDR';

export const NonPerformancePropertyCondition = z.enum([
  'Excellent',
  'Good',
  'Fair',
  'Poor',
  'Unknown or No Property Inspection',
  'Property Inaccessible',
  'Condemned',
]);
export type NonPerformancePropertyCondition = z.infer<typeof NonPerformancePropertyCondition>;

export const NonPerformancePropertyConditionToFreddieMacEDR: Record<
  NonPerformancePropertyCondition,
  FreddieMacEDRV1['propertyCondition']
> = {
  Excellent: '03',
  Good: '04',
  Fair: '05',
  Poor: '06',
  'Unknown or No Property Inspection': '10',
  'Property Inaccessible': '18',
  Condemned: '20',
};

// TODO find corresponding codes for Fannie Mae's "Default Reporting Application" report
